import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm } from '@angular/forms';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { from, Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { LimiteAgenteFinanceiro, LimiteContratacao } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { CanComponentDeactivate } from '../../../core/can-deactivate-guard.service';
import { OcorrenciaValidacaoVO } from '../../../shared/ocorrencia-validacao.vo';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';


@Component({
    selector: 'app-limite-cadastro',
    templateUrl: './limite-cadastro.component.html',
    styleUrls: ['./limite-cadastro.component.scss'],
    standalone: false
})
export class LimiteCadastroComponent extends BaseEntityComponent<LimiteAgenteFinanceiro>
  implements OnInit, CanComponentDeactivate, OnDestroy {

  ocorrencias: OcorrenciaValidacaoVO[] = [];
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private tranches: Tranche[] = [];
  private trancheSelecionada: Tranche;
  public click: boolean = false;
  parametros = ['nome', 'cnpj'];
  autocomplete;
  bnMaxHeight = 3;
  restUrl = "rest/front/agentes-financeiros";
  bnEntidade = 'id';
  bnLabel = 'nome';
  bnNomeId = 'id';
  bnLabelResultadoBusca = ['nome', 'cnpj']
  ehFGBS: boolean;
  private readonly destroy$ = new Subject();

  vc: BnConfirmDirective;
  //@ViewChild('meuId', {static: false}) botoesPersonalizados: TemplateRef<any>;
  @ViewChild('formLimiteAgente', {static: false}) form: NgForm;


  constructor(
    protected injector: Injector,
    private modalService: BnModalMessageService,
    private permissaoService: PermissaoService,
    private loadingService: BnLoadingService,
    private removerAlertasService: RemoverAlertasService,
    private agenteService: AgenteFinanceiroService,
    private limiteService: LimiteService,
    private trancheService: TrancheService,
    private modalidadeGarantiaService: ModalidadeGarantiaService,
  ) {
	  super(limiteService);
    this.config.rotaLista = '/limite/pesquisa';
    this.config.bloquearTelaAoRecuperarModelo = true;
  }

  ngOnInit() {
    this.modoEdicao = false;
    this.permissaoService.getPermissoesUsuarioAutenticado().pipe(takeUntil(this.destroy$)).subscribe((resp: any) => {
    	if (resp && resp[ROLE_GESTOR_ENVIO]) {
        this.agenteService.getAgentesFinanceiros().pipe(takeUntil(this.destroy$)).subscribe (agentes => {
          this.agentesFinanceiros = agentes;
          this.agentesFinanceiros = this.agentesFinanceiros
            .sort ((elemento1, elemento2) => (elemento1.nome > elemento2.nome) ? 1 : -1);
        });
        this.trancheService.getTranches().pipe(takeUntil(this.destroy$)).subscribe (tranches => {
          this.tranches = tranches;
          this.trancheSelecionada = tranches.reduce((t1, t2) => t1.numeroTranche > t2.numeroTranche ? t1 : t2);
          this.carregarDadosModalidadeFgbs();
        });
        setTimeout(() => this.recuperarModelo(), 0);
    	}
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  async carregarDadosModalidadeFgbs() {
    const modalidade = await this.modalidadeGarantiaService.buscarModalidade().toPromise();
    this.ehFGBS = modalidade.sigla === 'FGBS';
    if (this.ehFGBS) {
      let idTranche = this.tranches[0].id;
      this.atribuiTranche(idTranche);
    }
  }

  atribuiTranche(ideTranche) {
    this.trancheSelecionada = this.tranches.find(tranche => tranche.id == ideTranche);
    this.model.ideTranche = this.trancheSelecionada.id;
  }

  private instanciaPropriedadesObjetoSeNulas(limite: LimiteAgenteFinanceiro) {
    if (!limite.id) {
    	limite.id = null;
    }
    if (!limite.agenteFinanceiro) {
	  	const agente: AgenteFinanceiro = new AgenteFinanceiro();
	  	agente.id = null;
	  	agente.cnpj = '';
	  	agente.nome = '';
	  	limite.agenteFinanceiro = agente;
  	}
    if (!limite.valorLimite) {
      limite.valorLimite = new LimiteContratacao(0, 0, 0);
    }
  }

  private atribuiModel(model) {
    super.setModel(model);
    this.instanciaPropriedadesObjetoSeNulas(this.model);
  }

  recuperarModelo() {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const idLimiteAgenteTranche = params['id'];

      if (idLimiteAgenteTranche) {
        this.modoEdicao = true;
        this.buscarLimiteAgenteTranche(idLimiteAgenteTranche);
      } else {
        this.atribuiModel(this.limiteService.getNewEntity());
        this.modoEdicao = true;
      }
    });
  }

  buscarLimiteAgenteTranche(idLimiteAgenteTranche: number): void {
    this.loadingService.bloqueiaTela();
    this.limiteService.findById(idLimiteAgenteTranche)
      .pipe(takeUntil(this.destroy$)).subscribe(limite => {
    	  limite.id = idLimiteAgenteTranche;
        this.atribuiModel(limite);
        this.loadingService.liberaTela();
      });
  }


  salvar() {
    super.antesDeSalvar();
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    this.abreModalConfirmacao('Deseja confirmar o cadastro ou a alteração do limite deste agente financeiro?').pipe(takeUntil(this.destroy$)).subscribe(resp => {
      if (resp.value === 'ok') {
        this.limiteService['save'](this.model).pipe(takeUntil(this.destroy$)).subscribe(limiteRetornado => {
          this.setModel(limiteRetornado);
          this.aposSalvar();
        }, error => {
          console.log(error);
          this.ocorrencias = this.limiteService.ocorrencias;
        });
      }
    });
  }

  // @overide
  aposSalvar() {
    this.exibeMensagemSucesso();
    this.modoEdicao = false;
  }

  exibeMensagemSucesso(): void {
    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: 'Limite criado/atualizado com sucesso.'
    });
  }

  async verificaSePodeSair(): Promise<boolean> {
    const titulo = 'Confirmação';
    const mensagem = this.model.id != null ? 'Descartar alterações realizadas no limite ?' : 'Descartar novo cadastro de limite ?';

    try {
        const resultadoConfimacao = await this.modalService.abrirConfirm(titulo, mensagem).result;
        return resultadoConfimacao.value === 'ok';
    } catch (e) {
        return false;
    }
  }

  canDeactivate(): Promise<boolean> | boolean {
      if (this.form.pristine || !this.modoEdicao) { // formulário não "tocado" OU "aposSalvar()"
        return true;
      } else {
        //console.debug('dados do limite alterados');
        return this.verificaSePodeSair();
      }
  }

  public toggle() {
    this.click = true;
  }

  public toggleBack() {
    this.click = false;
  }

  abreModalConfirmacao(mensagem: string): Observable<{value: string}> {
    const titulo = 'Confirmação';
    const resultadoConfimacao: Promise<{value: string}> = this.modalService.abrirConfirm(titulo, mensagem).result;
    return from(resultadoConfimacao);
  }
}
